import React, { Component } from 'react';
import { noop } from '../Shared/utils';

class Thead extends Component {
  extractName = (name) => typeof name === 'function'
    ? name(this.props)
    : name;

  getHeadingContents = ({ name, sortable }, idx) => {
    const columnName = this.extractName(name);
    const {
      sort = {},
      isLoading,
    } = this.props;

    return isLoading
      ? columnName
      : (
        <span onClick={this.onClick({ sortable, idx })}>
          {columnName} {this.getSortingButton(sort, idx)}
        </span>
      );
  };

  getSortingButton = ({ columnIdx, direction }, idx) => (
    columnIdx === idx && (
      <button className="luna-table__sortBy" type="button">
        <svg className="luna-icon luna-icon--xsmall" aria-hidden="true">
          <use xlinkHref={`#arrow-${direction === 'desc' ? 'up' : 'down'}`}></use>
        </svg>
      </button>
    ));

  onClick = ({ idx, sortable = true }) => sortable !== false
    ? this.props.onColumnClick(idx)
    : noop;

  render() {
    return (
      <thead className="flexible-table__header">
        <tr>
          {this.props.columns.map((column, idx) => (
            <th className={column.className}
              key={idx}
              scope="col"
            >
              {this.getHeadingContents(column, idx)}
            </th>
          ))}
        </tr>
      </thead>
    );
  }
}

export default Thead;



// WEBPACK FOOTER //
// ./src/Table/Thead.js